/**
 * Returns true when an event is currently live (voting window open).
 */
export function isEventLive(event, now = new Date()) {
  if (!event || event.isDisabled) return false;
  if (!event.votingStartTime) return false;

  const votingStart = new Date(event.votingStartTime);
  const votingEnd = event.votingEndTime ? new Date(event.votingEndTime) : null;

  return now >= votingStart && (!votingEnd || now <= votingEnd);
}

/**
 * Returns all currently live events, sorted by votingStartTime ascending.
 */
export function getLiveEvents(events, now = new Date()) {
  return (events || [])
    .filter((event) => isEventLive(event, now))
    .sort((a, b) => new Date(a.votingStartTime) - new Date(b.votingStartTime));
}

/**
 * Resolves the best Live page path for a helper user.
 * Single live event → /events/live/:id; otherwise → /events/live (picker or empty state).
 */
export function getHelperLivePath(events, now = new Date()) {
  const live = getLiveEvents(events, now);
  if (live.length === 1) {
    return `/events/live/${live[0].id}`;
  }
  return "/events/live";
}

/**
 * Sets or clears the overlay currently shown on phones for one event.
 * A null template id means the overlay is hidden.
 */
export function withEventOverlay(events, eventId, overlayTemplateId) {
  const id = Number(eventId);
  if (!Number.isFinite(id)) return events || [];
  return (events || []).map((event) =>
    Number(event.id) === id
      ? { ...event, activeOverlayTemplateId: overlayTemplateId ?? null }
      : event
  );
}
